import { Component, Inject, OnInit } from '@angular/core';
import { InstrumentoAutoevaluacionAdminComponent } from '../../instrumento-autoevaluacion-admin/instrumento-autoevaluacion-admin.component';

@Component({
  selector: 'app-simulacion-instrumento-autoevaluacion',
  templateUrl: './simulacion-instrumento-autoevaluacion.component.html',
  styleUrls: ['./simulacion-instrumento-autoevaluacion.component.css']
})
export class SimulacionInstrumentoAutoevaluacionComponent implements OnInit {

  constructor(
    @Inject(InstrumentoAutoevaluacionAdminComponent) private parent: InstrumentoAutoevaluacionAdminComponent
  ) { }

  ngOnInit(): void {
  }

  volver(){
    this.parent.ngOnInit();
  }
}